import { SidebarVariant } from "../sidebarVariants";
import prop1 from "./proposal1";
import prop2 from "./proposal2";
//import prop3 from "./proposal3";

export const sidebarTheme = {
    [SidebarVariant.PROP1]: prop1,
    [SidebarVariant.PROP2]: prop2,
    //[SidebarVariand.PROP3]: prop3,
}